import React, { useRef } from "react";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";
import PageBanner from "../../containers/global/page-banner";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";
import PartnersData from "../../data/awards.json";

const AwardsRecognitionsPage = () => {
    const contRef = useRef(null);

    const handleScrollToHeader = () => {
        if (contRef.current) {
            const headerPosition = contRef.current.offsetTop;
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };

    return (
        <React.Fragment>
            <Layout>
                <SEO title="Awards & Recognitions | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header onPressSkipButton={handleScrollToHeader} />
                    <PageBanner
                        title="Awards & Recognitions"
                        excerpt=""
                        image="/images/banner/page/awards-recognitions.png"
                    />

                    <div className="container">
                        <div className="section-title text-center"></div>
                        <br />

                        <div
                            id="grid"
                            className="grid row mb-n8 justify-content-center"
                        >
                            {PartnersData.map((award) => (
                                <div
                                    key={award.id}
                                    className="grid-item mb-7 col-md-3 col-sm-6 d-flex"
                                >
                                    <div
                                        className="feature-card bg-light text-center p-4 w-100"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            borderRadius: "12px",
                                            boxShadow:
                                                "0 4px 12px rgba(0,0,0,0.08)",
                                            minHeight: "400px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                height: "180px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <img
                                                src={award.thumb}
                                                alt={`Award ${award.id}`}
                                                className={award.class}
                                                style={{
                                                    maxHeight: "100%",
                                                    maxWidth: "100%",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                minHeight: "140px",
                                                display: "flex",

                                                justifyContent: "center",
                                                padding: "0 10px",
                                                textAlign: "center",
                                            }}
                                        >
                                            <ul className="list-unstyled p-0 m-0">
                                                <li
                                                    style={{
                                                        fontSize: "14px",
                                                        lineHeight: "1.4",
                                                    }}
                                                >
                                                    {award.details}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <br />
                <Footer />
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default AwardsRecognitionsPage;
